
import { Vue, Component, Prop, Watch, Model } from 'vue-property-decorator';

@Component
export default class DescriptionField extends Vue {
  val = '';


  templateList = [
    {
      title: '模版1',
      Template: '车况良好（中等使用痕迹\n外观：\n车身漆面整体保持较好，存在少量细小划痕和轻微磨损，无明显凹陷或大面积补漆。前后灯组功能正常，玻璃完好无损。\n内饰：\n内饰干净整洁，座椅无明显磨损，皮革/织物表面基本完好。空调、音响、电动门窗等功能操作正常，仪表盘显示清晰。\n驾驶：\n发动机运转平稳，动力响应良好，变速箱换挡顺畅，无明显顿挫感。刹车灵敏，转向无异响，底盘稳定性佳。\n整体介绍：\n车辆整体车况良好，日常使用痕迹较少，无重大事故记录，保养记录齐全，适合家用通勤，性价比高。',
    },
    {
      title: '模版2',
      Template: '准新车（极少使用，近乎完美）\n外观：\n车身漆面光亮如新，无明显划痕或损伤，轮毂无刮擦，轮胎花纹清晰。所有灯光及反光镜功能正常。\n内饰：\n内饰保持原厂状态，座椅无褶皱或污渍，中控台按键操作灵活，多媒体系统运行流畅，无异味。\n驾驶：\n发动机动力充沛，起步加速顺畅，变速\n箱逻辑清晰，换挡迅速无延迟。刹车灵敏，悬挂舒适性良好。\n整体介绍：\n该车为准新车，行驶里程极低，几乎无使用痕迹，配置齐全，性能稳定，适合对车况要求较高的用户。',
    },
    {
      title: '模版3',
      Template: '一般车况（正常使用，有明显使用痕迹）\n外观：\n车身存在多处细小划痕，局部有补漆痕迹，前保险杠或车门有轻微磕碰，整体仍可接受。\n内饰：\n座椅有一定磨损，部分区域有褶皱或轻微污渍，中控屏操作正常，但部分按键略有老化或松动。\n驾驶：\n发动机启动正常，动力输出稳定，变速箱换挡略有顿挫感，高速行驶时偶有异响，不影响正常使用。\n整体介绍：\n车辆为日常使用状态，车况中等，适合预算有限、对细节要求不高的用户，建议后期做适当整备。',
    },
    {
      title: '模版4',
      Template: '事故修复车（曾发生过事故，已修复）\n外观：\n车身结构有修复痕迹，局部钣金处理较明显，漆面颜色存在细微色差，具体部位需进一步检查确认。\n内饰：\n内饰基本完整，未见严重损坏，部分电子功能可能存在间歇性故障，需进一步测试确认。\n驾驶：\n发动机与变速箱工作正常，但底盘或悬挂可能存在一定影响，建议由专业人员进行全面评估。\n整体介绍：\n该车曾发生过一次轻微/中度事故（如前部碰撞或侧撞），已完成维修并恢复使用，适合用于代步或二次整备。',
    },
    {
      title: '模版5',
      Template: '多处损伤（车况较差，需整备）\n外观：\n车身存在多处划痕、凹陷及掉漆，部分区域补漆不均匀，前/后保险杠有明显撞击痕迹。\n内饰：\n座椅磨损严重，有明显褶皱或破损，中控按键部分失灵，车内存在轻微异味。\n驾驶：\n发动机冷启动稍显吃力，变速箱换挡有顿挫感，行驶过程中存在异响，需检修。\n整体介绍：\n车辆整体车况较差，外观与机械系统均有明显问题，建议全面整备后再使用，适合用于维修或拆件用途。',
    },
    {
      title: '模版6',
      Template: '水泡/火烧车（特殊事故车，风险较高）\n外观：\n车身外观基本完好，但水泡/火烧痕迹主要集中在内饰及电路系统，外部损伤较小。\n内饰：\n地板潮湿或发霉，中控台有水渍或烧焦痕迹，部分电子设备无法正常工作，存在异味。\n驾驶：\n发动机启动不稳定，电气系统存在故障，部分控制模块失效，需全面检修。\n整体介绍：\n该车曾遭受水泡/火烧事故，存在较大安全隐患，建议由专业机构全面检测评估，仅限用于维修或拆解用途。',
    },
  ];

  selectTempla(item: any) {
    this.val = item.Template;
    this.$emit('update', this.val);
  }

  @Model('change', {
    type: String,
  })
  value!: string;


  @Prop()
  readonly!: boolean;

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = this.value;
    } else {
      this.val = '';
    }
  }

  mounted() {
    this.watchValue();
  }
}
